import axios, { InternalAxiosRequestConfig } from "axios";
import { message } from "ant-design-vue";

// 创建axios实例

const baseUrl = "http://admin.wozhida.cn/api/";
// const baseUrl = "http://www.wozhida.cn/api/";

const $axios = axios.create({
  baseURL: baseUrl,
  timeout: 200000, // 请求超时时间
});

// request拦截器
$axios.interceptors.request.use(
  (config) => {
    config.headers["Content-type"] = "application/json";
    config.headers["X-SS-API-KEY"] = "020383de-03a9-4c45-b368-897a70de988a";

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// respone拦截器
$axios.interceptors.response.use(
  (response) => {
    // console.log(response);
    // const loadingInstance = ElLoading.service()
    if (response.status !== 200) {
      message.error("出错了");
      return response.data;
    } else {
      return response.data;
    }
  },
  (error) => {
    message.error(error.message);
    return Promise.reject(error);
  }
);

export default $axios;

// let subscribers = [] as any;

// // 执行队列
// function onAccessTokenFetched() {
//   subscribers.forEach((callback: any) => {
//     callback();
//   });
//   subscribers = [];
// }

// // 添加队列
// function addSubscriber(callback: any) {
//   subscribers.push(callback);
// }

// function instance(config: InternalAxiosRequestConfig<any>): any {
//   throw new Error("Function not implemented.");
// }
